import * as React from "react";
import { Base } from "../../framework/base";

interface IStateTextProps {
    classes: string;
    state: number;
    borderedHeight?: string;
    stateColor: string;
    stateText: string;
};

export const StateText = (props: IStateTextProps) => {
    const stateColor = props.stateColor ?? "#fff";
    const bordered = Base.isWhite(stateColor);

    return (
        <span
            className={`stateText ${props.classes} state` + props.state.toString(10)}
            style={{
                background: stateColor,
                color: Base.invertColor(stateColor, true),
                border: bordered ? "1px solid lightgray" : null,
                lineHeight: bordered ? (props.borderedHeight ?? "16px") : null
            }}>
            {props.stateText}
        </span>
    );
};
